<template>
  <section v-if="traditions.length" id="traditions" class="traditions-section">
    <v-container>
      <p>The Experiences That Returned</p>
      <h2>Traditions</h2>
      <div class="traditions-grid">
        <article v-for="tradition in traditions" :key="tradition.title">
          <h3>{{ tradition.title }}</h3>
          <p>{{ tradition.description }}</p>
          <span>{{ tradition.years.join(' · ') }}</span>
        </article>
      </div>
    </v-container>
  </section>
</template>

<script>
export default { name: 'RecurringTraditions', props: { traditions: { type: Array, default: () => [] } } };
</script>

<style scoped>
.traditions-section { background: #0b0b0b; border-top: 1px solid #242424; padding: 76px 0; scroll-margin-top: 68px; }
.traditions-section > .container > p { color: #e23232; font-family: "Oswald", sans-serif; font-weight: 800; text-transform: uppercase; }
h2 { color: #fff; font-family: "Oswald", sans-serif; font-size: clamp(2.2rem, 5vw, 3.2rem); margin: 0 0 28px; }
.traditions-grid { display: grid; gap: 14px; grid-template-columns: repeat(auto-fit, minmax(230px, 1fr)); }
.traditions-grid article { border-left: 3px solid #f0b13c; background: #141414; border-radius: 0 10px 10px 0; padding: 23px; }
h3 { color: #fff; font-family: "Oswald", sans-serif; font-size: 1.35rem; margin: 0 0 10px; }
.traditions-grid p { color: #bbb; line-height: 1.55; margin: 0 0 16px; }
.traditions-grid span { color: #f0b13c; font-size: 0.78rem; font-weight: 800; }
</style>
